import { KeyboardEvent } from "react";

import "./style.scss";
import CheckboxIcon from "../../assets/checkbox.icon.svg";
import CheckboxDarkIcon from "../../assets/checkbox--dark.icon.svg";
import CheckboxCheckedIcon from "../../assets/checkbox-checked.icon.svg";
import CheckboxCheckedDarkIcon from "../../assets/checkbox-checked--dark.icon.svg";
import { ThemeContainer } from "../../common/containers/theme/theme.container";

export const ImageCheckbox = ({
    checked,
    onChange,
    icon,
    checkedIcon,
    ariaLabel
}: {
    checked: boolean;
    onChange?: () => void;
    icon?: string;
    checkedIcon?: string;
    ariaLabel?: string;
}) => {
    const { isLightTheme } = ThemeContainer.useContainer();
    const currentIcon = icon ?? (isLightTheme ? CheckboxIcon : CheckboxDarkIcon);
    const currentCheckedIcon =
        checkedIcon ?? (isLightTheme ? CheckboxCheckedIcon : CheckboxCheckedDarkIcon);

    // Keyboard operability (WCAG 2.1.1): Space/Enter re-dispatch a click so the
    // toggle handler runs — whether that's this component's onClick or (as in
    // menu-filter) an onClick on a wrapping MUI FormControlLabel that the click
    // bubbles up to.
    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === " " || event.key === "Enter") {
            event.preventDefault();
            event.currentTarget.click();
        }
    };

    return (
        <div className="image-checkbox">
            <div
                className="image-checkbox__icon"
                role="checkbox"
                aria-checked={checked}
                aria-label={ariaLabel}
                tabIndex={0}
                style={{
                    backgroundImage: checked ? `url(${currentCheckedIcon})` : `url(${currentIcon})`
                }}
                onClick={onChange}
                onKeyDown={handleKeyDown}
            ></div>
        </div>
    );
};
